import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class MstSectionService {
  mstSection: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'mst_section/list/?';
  private DeListRecord = webapi + 'mst_section/deactivated_list/?';
  private AddRecord = webapi + 'mst_section/create';
  private EditRecord = webapi + 'mst_section/update';
  private GetRecord = webapi + 'mst_section/byid/';
  private GetRecordbystate = webapi + 'mst_section/sectionbyID/';
  private GetRecordbydistrict = webapi + 'mst_section/sectionbyDistID/';
  private DeleteRecord = webapi + 'mst_section/delete/';
  private ReActiveRecord = webapi + 'mst_section/reActive/';
  private ListRecordByDsfId = webapi + 'mst_dsf_field/getsectionlistbydsfid/';


    constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllDeactivatedRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.DeListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    reActiveRecordService(id: any) {
        return this.http.put(this.ReActiveRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

 getRecordServiceByDsfId(id: any) {
    return this.http.get(this.ListRecordByDsfId + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordServicestate(id: any) {
    return this.http.get(this.GetRecordbystate + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    getAllRecordServicedistrict(id: any) {
        return this.http.get(this.GetRecordbydistrict + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mst-section/mst-section.service.ts